import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const PredictionProductIcon = (props: SvgProps & { fill?: string }) => (
    <Svg width={16} height={16} {...props} fill="none" viewBox="0 0 16 16">
        <Path
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M13.4401 6.55988C13.4401 9.56431 11.0045 11.9999 8.00006 11.9999C4.99563 11.9999 2.56006 9.56431 2.56006 6.55988C2.56006 3.55545 4.99563 1.11988 8.00006 1.11988"
        />
        <Path
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M3.99988 13.8572C5.18685 14.5092 6.55014 14.8801 8.00006 14.8801C9.44997 14.8801 10.8133 14.5092 12.0002 13.8572"
        />
        <Path
            fill={props.fill || ds.colorValue.icon.primary}
            stroke={props.fill || ds.colorValue.icon.primary}
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M10.7199 1.2498L10.7713 1.63174C10.8911 2.52194 10.951 2.96704 11.2412 3.26352C11.5314 3.56 11.9751 3.62942 12.8625 3.76826L12.94 3.78038L12.8633 3.79235C11.9755 3.93089 11.5316 4.00016 11.2413 4.29667C10.9509 4.59319 10.891 5.03844 10.7711 5.92895L10.7199 6.3098L10.6687 5.92913C10.5489 5.03854 10.489 4.59324 10.1986 4.2967C9.90825 4.00015 9.46432 3.93087 8.57645 3.79231L8.5 3.78038L8.57726 3.76829C9.46479 3.62944 9.90856 3.56001 10.1988 3.26348C10.489 2.96695 10.5488 2.52179 10.6685 1.63148L10.7199 1.2498Z"
        />
    </Svg>
);
